import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/EmailLogin/signInPageCopy";

/**
 * UI2 Sign in page copy — wired through scoped I18n (see translate mirror).
 */
export function createSignInPageCopy(locale?: string) {
  const I18n = I18nUtil.createScoped(Translations, locale);
  return {
    headlinePrefix: I18n.t("Meet your "),
    headlineAccent: I18n.t("money person"),
    subtitle: I18n.t("Log in or create your account."),
    emailPlaceholder: I18n.t("Enter your email"),
    continueWithEmail: I18n.t("Continue with Email"),
    orContinueWith: I18n.t("or continue with"),
    verifyTitle: I18n.t("Check your email"),
    verifySubtitlePrefix: I18n.t("We sent a 6-digit code to"),
    invalidCode: I18n.t("Invalid verification code"),
  } as const;
}

export type SignInPageCopy = ReturnType<typeof createSignInPageCopy>;

/** Backward-compatible default for legacy callsites/tests (English locale). */
export const SIGN_IN_PAGE_COPY = createSignInPageCopy();
